import axios from "../api/axios"
import useAuth from "./useAuth"

 export default function useRefreshToken() {
    const { setAuth } = useAuth()

    const refresh = async () => {
        try{
            const res = await axios.post('/api/admin/auth/generate-token', {withCredentials: true});
            
            const accessToken = res?.data?.token;
            const userDetails = res?.data?.userDetails;
            setAuth({
                token: accessToken,
                name: userDetails.fullname,
                role: userDetails.role,
            });
            return accessToken
        }
        catch(error){
            setAuth(null)
            return null;
        }
    }
   return refresh
 }
 